// FETCH ALL FEEDBACK DETAILS
export const FETCH_FEEDBACK_DETAILS_REQUEST = 'FETCH_FEEDBACK_DETAILS_REQUEST';
export const FETCH_FEEDBACK_DETAILS_SUCCESS = 'FETCH_FEEDBACK_DETAILS_SUCCESS';
export const FETCH_FEEDBACK_DETAILS_FAILURE = 'FETCH_FEEDBACK_DETAILS_FAILURE';

// CREATE FEEDBACK DETAILS
export const CREATE_FEEDBACK_DETAILS_REQUEST = 'CREATE_FEEDBACK_DETAILS_REQUEST';
export const CREATE_FEEDBACK_DETAILS_SUCCESS = 'CREATE_FEEDBACK_DETAILS_SUCCESS';
export const CREATE_FEEDBACK_DETAILS_FAILURE = 'CREATE_FEEDBACK_DETAILS_FAILURE';

// UPDATE FEEDBACK DETAILS
export const UPDATE_FEEDBACK_DETAILS_REQUEST = 'UPDATE_FEEDBACK_DETAILS_REQUEST';
export const UPDATE_FEEDBACK_DETAILS_SUCCESS = 'UPDATE_FEEDBACK_DETAILS_SUCCESS';
export const UPDATE_FEEDBACK_DETAILS_FAILURE = 'UPDATE_FEEDBACK_DETAILS_FAILURE';

// FETCH SINGLE STATE OF FEEDBACK DETAILS
export const FETCH_SINGLE_FEEDBACK_DETAILS_REQUEST = 'FETCH_SINGLE_FEEDBACK_DETAILS_REQUEST';
export const FETCH_SINGLE_FEEDBACK_DETAILS_SUCCESS = 'FETCH_SINGLE_FEEDBACK_DETAILS_SUCCESS';
export const FETCH_SINGLE_FEEDBACK_DETAILS_FAILURE = 'FETCH_SINGLE_FEEDBACK_DETAILS_FAILURE';

// DELETE FEEDBACK DETAILS
export const DELETE_FEEDBACK_DETAILS_REQUEST = 'DELETE_FEEDBACK_DETAILS_REQUEST';
export const DELETE_FEEDBACK_DETAILS_SUCCESS = 'DELETE_FEEDBACK_DETAILS_SUCCESS';
export const DELETE_FEEDBACK_DETAILS_FAILURE = 'DELETE_FEEDBACK_DETAILS_FAILURE';

// FETCH ALL FEEDBACK TYPE FROM PROPERTY
export const FETCH_FEEDBACK_DATA_FROM_PROPERTY_REQUEST = 'FETCH_FEEDBACK_DATA_FROM_PROPERTY_REQUEST';
export const FETCH_FEEDBACK_DATA_FROM_PROPERTY_SUCCESS = 'FETCH_FEEDBACK_DATA_FROM_PROPERTY_SUCCESS';
export const FETCH_FEEDBACK_DATA_FROM_PROPERTY_FAILURE = 'FETCH_FEEDBACK_DATA_FROM_PROPERTY_FAILURE';

export const RESET_FEEDBACK_DETAILS_INFO = 'RESET_FEEDBACK_DETAILS_INFO';

export const CREATE_FEEDBACK_DETAILS_FORM = 'CREATE_FEEDBACK_DETAILS_FORM';

export const UPDATE_FEEDBACK_DETAILS_FORM = 'UPDATE_FEEDBACK_DETAILS_FORM';
